module.exports = __webpack_public_path__ + "img/Logo-Vertical-Blanco.eb1133fe.png";